<h4 mat-dialog-title><i class="fas fa-plus mr-1"></i> Zone</h4>

<mat-dialog-content class="mat-typography mt-0">
    <div class="row">
        <div class="col-12 mt-2">
          <div class="table-responsive db-block" style="height: auto !important;">
          <table mat-table [dataSource]="dataSource" class="gridData mt-2" matSort>
            <ng-container matColumnDef="zoneId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Zone ID</th>
              <td mat-cell *matCellDef="let element">
                <span *ngIf="getZoneName(element) == 'Zone Deleted!'" class="badge badge-danger">####</span>
                <span *ngIf="getZoneName(element) != 'Zone Deleted!'">{{element.zoneId}}</span>
              </td>
            </ng-container>
    
            <ng-container matColumnDef="zoneName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Zone Name</th>
              <!-- <td mat-cell *matCellDef="let element"> {{element.zoneName}} </td> -->
              <td mat-cell *matCellDef="let element">
                
                <span *ngIf="getZoneName(element) == 'Zone Deleted!'" class="badge badge-danger">{{getZoneName(element)}}</span>
                <span *ngIf="getZoneName(element) != 'Zone Deleted!'">{{getZoneName(element)}}</span>
                <!-- <input type="text" readonly class="bg-transparent border-0 text-white-50" [value]="getZoneName(element)"/> -->
              </td>
            </ng-container>
    
            <!-- Hide Delete Zone Button Bcz of Requirement -->
            <ng-container matColumnDef="actions" hidden>
              <th mat-header-cell *matHeaderCellDef hidden>Action</th>
              <td mat-cell *matCellDef="let element" hidden>
  
                <button mat-icon-button  matTooltip="Click to Delete" (click)="getTempId(element)" class="iconbutton text-danger" data-toggle="modal" data-target="#deletePrompt">
                  <mat-icon aria-label="Delete">delete</mat-icon>
                </button> 
                
                <div class="modal fade" id="deletePrompt" tabindex="1050" role="dialog" aria-labelledby="deletePromptLabel" aria-hidden="true">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title orange-text" id="deletePromptLabel">Delete Zone </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                        </div>
                        <div class="modal-body">
                          Are you sure you want to delete this Zone?
                        </div>
                        <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-danger" (click)="deleteGeoFenceZone(tempId)" data-dismiss="modal">Confirm</button>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>
    
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
          <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
        </div>
      </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-light float-right" (click)="closeDialog()">
        <i class="fas fa-times mr-1"></i> Cancel</button>
</mat-dialog-actions>